import type { MechKey } from './keys';

export const ja: Partial<Record<MechKey, string>> = {
  'app.eyebrow': '力学 · 2D',
  'panel.scene': 'シーン',
  'panel.dims': 'パラメータ',
  'panel.style': '外観',
  'panel.action': 'コントロール',
  'style.body': '物体',
  'style.vector': 'ベクトル',
  'style.ground': '地面',
  'style.forces': '力を表示',
  'style.trace': '軌跡を表示',
  'style.labels': 'ベクトルラベル',
  'hint.line1': '再生をクリックして開始 · 物体をドラッグして移動',
  'hint.line2': 'サンドボックス：形を選んでクリックして配置',
  'scene.incline': '斜面',
  'scene.projectile': '投射運動',
  'scene.pendulum': '振り子',
  'scene.springMass': 'ばね質量系',
  'scene.collisions': '衝突',
  'scene.atwood': 'アトウッドの機械',
  'scene.circular': '円運動',
  'scene.sandbox': 'サンドボックス',
  'dim.angle': '角度 (°)',
  'dim.friction': '摩擦',
  'dim.mass': '質量',
  'dim.massA': '質量 A',
  'dim.massB': '質量 B',
  'dim.velocity': '速度',
  'dim.angleLaunch': '発射角度 (°)',
  'dim.gravity': '重力',
  'dim.gravityX': '重力 x',
  'dim.gravityY': '重力 y',
  'dim.length': '長さ',
  'dim.damping': '減衰',
  'dim.spring': '剛性',
  'dim.restitution': '反発係数',
  'dim.radius': '半径',
  'dim.speed': '速さ',
  'action.play': '再生',
  'action.pause': '一時停止',
  'action.step': 'ステップ',
  'action.reset': 'リセット',
  'action.speed': '速度',
  'action.clear': 'クリア',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': '重力',
  'forceName.normal': '垂直抗力',
  'forceName.friction': '摩擦力',
  'forceName.tension': '張力',
  'forceName.spring': 'ばね力',
  'forceName.applied': '外力',
  'forceName.air': '空気抵抗',
  'palette.box': '箱',
  'palette.circle': 'ボール',
  'palette.ramp': '斜面',
  'palette.ground': '地面',
  'palette.hint': '形を選んでキャンバスをクリックして配置してください。',
  'panel.forces': '観測された力',
  'forces.empty': 'まだなし — シーンを再生してください',
};
